import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from '@/hooks/useAppSelector';
import { PORTAL_BRANDING } from '@/config/portalConfig';
import type { PortalCode } from '@/types/identity';

const PORTAL_PATHS: Record<string, PortalCode> = {
  customer: 'CUSTOMER',
  vendor: 'VENDOR',
  employee: 'EMPLOYEE',
  candidate: 'CANDIDATE',
  delivery: 'DELIVERY',
  partner: 'PARTNER',
};

export function PortalScopeGuard() {
  const session = useAppSelector((s) => s.identity.session);
  const { pathname } = useLocation();

  if (!session) {
    return <Navigate to="/identity/login" replace />;
  }

  const segments = pathname.split('/').filter(Boolean);
  const portalSegment = segments[1];
  const pathPortal = portalSegment ? PORTAL_PATHS[portalSegment] : null;

  if (pathPortal && pathPortal !== session.activePortalCode) {
    return <Navigate to={PORTAL_BRANDING[session.activePortalCode].homePath} replace />;
  }

  return <Outlet />;
}
